"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeFile = exports.readFile = void 0;
var read_1 = require("./read");
Object.defineProperty(exports, "readFile", { enumerable: true, get: function () { return read_1.readFile; } });
var write_1 = require("./write");
Object.defineProperty(exports, "writeFile", { enumerable: true, get: function () { return write_1.writeFile; } });
//# sourceMappingURL=index.js.map